import store from '@/store'
import { getToken } from '@/utils/auth'
import { isTokenExpired } from '@/utils/jwt'
import { isSchedulerRoute, isAIRoute } from '@/utils/features'

export function registerGuards(router) {
  router.beforeEach(async (to, from, next) => {
    if (!store.getters['auth/sessionReady']) {
      await store.dispatch('auth/bootstrapSession')
    }

    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
    const token = getToken()

    if (token && isTokenExpired(token)) {
      await store.dispatch('auth/logout')
      return next({ name: 'Login', query: { redirect: to.fullPath } })
    }

    const isLoggedIn = store.getters['auth/isLoggedIn']

    const allowLoggedIn = to.matched.some((record) => record.meta.allowLoggedIn)
    if (!requiresAuth && isLoggedIn && to.name !== 'Landing' && !allowLoggedIn) {
      return next({ name: 'Dashboard' })
    }

    if (requiresAuth && !isLoggedIn) {
      return next({ name: 'Login', query: { redirect: to.fullPath } })
    }

    const requiresAdmin = to.matched.some((record) => record.meta.requiresAdmin)
    if (requiresAdmin && store.getters['auth/role'] !== 'admin') {
      return next({ name: 'Dashboard' })
    }

    if (isLoggedIn && store.getters['auth/role'] !== 'admin') {
      if (!store.getters['app/featureSettings'].loaded) {
        await store.dispatch('app/fetchFeatureSettings')
      }
      if (store.getters['app/hideScheduler'] && isSchedulerRoute(to.path)) {
        return next({ name: 'Dashboard' })
      }
      if (store.getters['app/hideAI'] && isAIRoute(to.path)) {
        return next({ name: 'Dashboard' })
      }
    }

    return next()
  })

  router.afterEach((to) => {
    document.title = `${to.meta.title || 'App'} - SocialLabs`
  })
}
